const Dashboard: React.FC = () => <div>Dashboard</div>;

export default Dashboard;
